import React, {Component} from 'react';
import {
  tryUpdatePayment,
  tryDeletePayment
} from 'actions/PaymentActions';

class CostDetailRow extends Component {
  state={
    mode: 'init',
    newAmount: 0,
    amountError: false,
    newNotes: "",
    notesError: false
  }

  handleAmountChange = (e) => {
    let val = e.target.value;

    this.setState({
      newAmount: val,
      amountError: this.props.validAmount(val)
    });
  }

  handleNotesChange = (e) => {
    let val = e.target.value;

    this.setState({
      newNotes: val,
      notesError: this.props.validNotes(val)
    });
  }

  resetMode = () => {
    this.setState({
      mode: "init"
    })
  }

  activeEditing = () => {
    this.setState({
      mode: "edit", 
      newAmount: this.props.amount,
      newNotes: this.props.notes
    })
  }

  activeDeleting = () => {
    this.setState({
      mode: "delete"
    })
  }

  handleDelete = (cid, id, cate) => {
    return () => {
      this.props.dispatch(tryDeletePayment(cid, id, cate));
      this.resetMode();
    }
  }

  handleEdit = (cid, id, cate) => {
    return () => {
      let {newAmount, newNotes} = this.state;
      let inValidAmount = this.props.validAmount(newAmount);
      let inValidNotes = this.props.validNotes(newNotes); 

      if (inValidAmount || inValidNotes) {
        this.setState({amountError: inValidAmount, notesError: inValidNotes})
      } else {
        this.props.dispatch(tryUpdatePayment(cid, id, cate, parseFloat(newAmount, 10), newNotes));
        this.resetMode();
      }
    }
  }

  render() {
    let {id, amount, notes, workOn, cate} = this.props;
    let {mode, newAmount, amountError, newNotes, notesError} = this.state;
    
    const ActionBlock = () => (mode === "init"?
        <div className="table-action-block">
          <span 
            className="glyphicon glyphicon-pencil"
            onClick={this.activeEditing} />
          <span 
            className="glyphicon glyphicon-trash"
            onClick={this.activeDeleting} />
        </div>
      :
        <div className="table-action-block">
          <span 
            className="glyphicon glyphicon-ok"
            onClick={(mode === "edit" ? this.handleEdit(workOn, id, cate) : this.handleDelete(workOn, id, cate))} />
          <span 
            className="glyphicon glyphicon-remove"
            onClick={this.resetMode} />        
        </div>
    )

    return (mode === "edit" ?
        <tr className="table-cost-detail">
          <td>
            <div className={"form-group" + (notesError? " has-error" : "")}>
              <input 
                type="text"
                className="form-control" 
                onChange={this.handleNotesChange}
                value={newNotes} />
            </div>
          </td>
          <td>
            <div className={"form-group" + (amountError? " has-error" : "")}>
              <input 
                type="number"
                className="form-control" 
                onChange={this.handleAmountChange}
                value={newAmount} />
            </div>
            <ActionBlock />
          </td>
        </tr>
      :
        <tr className="table-cost-detail">          
          <td>{notes}</td>
          <td>${amount}
            <ActionBlock />
          </td>
        </tr>
      )
  }
}

export default CostDetailRow;


// WEBPACK FOOTER //
// ./src/components/Construction/CostDetailRow.js